import { render, staticRenderFns } from "./HelpDetail.vue?vue&type=template&id=09dfdd8d&scoped=true"
import script from "./HelpDetail.vue?vue&type=script&lang=js"
export * from "./HelpDetail.vue?vue&type=script&lang=js"
import style0 from "./HelpDetail.vue?vue&type=style&index=0&id=09dfdd8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dfdd8d",
  null
  
)

export default component.exports